<!--<template>-->
<!--  <div id="index" ref="appRef">-->
<!--    <div class="bg">-->
<!--      <dv-loading v-if="loading">Loading...</dv-loading>-->
<!--      <div v-else class="host-body">-->
<!--        <div class="d-flex jc-center">-->
<!--          <dv-decoration-10 class="dv-dec-10" />-->
<!--          <Icon @click="showIsFull" class="link_btns" v-if="!isFullScreen" :type="!isShow ? 'md-contract' : 'md-expand'" :size="25"></Icon>-->
<!--          <div class="d-flex jc-center">-->
<!--            <dv-decoration-8 class="dv-dec-8" :color="['#568aea', '#000000']" />-->
<!--            <div class="title">-->
<!--              <span class="title-text">{{ titles }}</span>-->
<!--              <dv-decoration-6 class="dv-dec-6" :reverse="true" :color="['#50e3c2', '#67a1e5']" />-->
<!--            </div>-->
<!--            <dv-decoration-8 class="dv-dec-8" :reverse="true" :color="['#568aea', '#000000']" />-->
<!--          </div>-->
<!--          <dv-decoration-10 class="dv-dec-10-s" />-->
<!--        </div>-->
<!--      </div>-->
<!--      &lt;!&ndash; 第三行数据 &ndash;&gt;-->
<!--      <Row :gutter="25" style="margin-top: 8px; position: relative; height: 85%">-->
<!--        <Col span="6" style="padding-left: 20px; position: relative">-->
<!--          <div class="header_bg">-->
<!--            <leftPage ref="leftPage" v-if="sonRefresh"></leftPage>-->
<!--          </div>-->
<!--        </Col>-->
<!--        <Col span="12">-->
<!--          <div class="header_bg">-->
<!--            <middlePage ref="middlePage" v-if="sonRefresh"></middlePage>-->
<!--          </div>-->
<!--        </Col>-->
<!--        <Col span="6" style="padding-right: 30px; position: relative">-->
<!--          <div class="header_bg">-->
<!--            <router-link v-show="isFullScreen" class="link_btn" tag="a" target="_blank" :to="{ name: 'largeScreen' }">全屏</router-link>-->
<!--            &lt;!&ndash; <div v-if="!isFullScreen&&isShow" @click="showIsFull" class="link_btn">铺满</div> &ndash;&gt;-->
<!--            &lt;!&ndash; <div v-if="!isFullScreen&&isShow" @click="showIsFull" class="link_btn">铺满</div> &ndash;&gt;-->
<!--            <rightPage ref="rightPage" v-if="sonRefresh"></rightPage>-->
<!--          </div>-->
<!--        </Col>-->
<!--      </Row>-->
<!--    </div>-->
<!--  </div>-->
<!--</template>-->
<template>
  <div>
    <Menu
      mode="horizontal"
      :active-name="menu_name"
      @on-select="selectMenu"
      style="width: 100%"
    >
      <div
        v-for="(v, k) in menus"
        :key="k"
        style="display: inline-block"
        v-auth="v.auth"
      >
        <MenuItem
          :name="v.name"
          @click="v.onClick"
          v-show="v.show === true ? false : true"
        >
          <Badge
            :overflow-count="10000000"
            v-if="v.badge && v.badge.count"
            :count="v.badge.count"
            :offset="[18, -3]"
          >
            {{ v.label }}
          </Badge>
          <span v-if="!(v.badge && v.badge.count)">
            {{ v.label }}
          </span>
        </MenuItem>
      </div>
    </Menu>
    <div
      v-if="width && height"
      id="iframeBox"
      :style="{
        width: `${width}px`,
        height: `${height}px`,
        position: 'relative',
      }"
    >
      <div
        style="
          display: flex;
          justify-content: right;
          flex-direction: column;
          position: absolute;
          right: 20px;
          top: 15px;
        "
        @click="onC()"
      >
        <div style="color: red">复制对外展示链接</div>
        <!-- <Icon :size="30" type="md-expand"></Icon> -->
        <Icon :size="36" type="ios-copy" style="color: red" />
      </div>
      <!-- <div
        style="
          display: flex;
          justify-content: right;
          position: absolute;
          right: 20px;
          top: 20px;
        "
        @click="onC()"
      >
        <Icon :size="30" type="md-expand"></Icon>
      </div> -->
      <!--    <Iframe-->
      <!--            :url="url"-->
      <!--            :Authorization="Authorization"-->
      <!--            :allowfullscreen="true"-->
      <!--            allow="fullscreen"-->
      <!--            :customerId="customerId"-->
      <!--            class="iframe1" id="iframe1">-->
      <!--    </Iframe>-->
      <iframe
        id="iframe"
        name="iframe"
        height="100%"
        width="100%"
        allow="fullscreen"
        :src="url"
      ></iframe>
    </div>
  </div>
</template>
<script>
// import leftPage from './data/leftPage.vue' // 左部分
// import middlePage from './data/middlePage.vue' // 中间
// import rightPage from './data/rightPage.vue' // 右边
// import screenfull from 'screenfull'
// import config from '@/../config'

import Iframe from "@/views/components/base/Iframe";
import Viewport from "@/utils/viewport";

// export default {
//   name: 'home',
//   data() {
//     return {
//       env_type: config.env_type,
//       titles: "",
//       timing: null,
//       loading: true,
//       dateDay: null,
//       dateYear: null,
//       dateWeek: null,
//       weekday: ['周日', '周一', '周二', '周三', '周四', '周五', '周六'],
//       isFullScreen: true,
//       isShow: true,
//       sonRefresh: true,
//     }
//   },
//   components: {
//     leftPage,
//     middlePage,
//     rightPage,
//   },
//   mounted() {
//     window.addEventListener('resize', () => {
//       this.autodivheight()
//     })
//     this.cancelLoading()
//     let lock = false;
//     let sleep = function(i){
//       return new Promise(function (resolve, reject) {
//         setTimeout(function(){
//           resolve();
//         },i*1000);
//       })
//     }
//     this.$refs.leftPage.initChart();
//     this.$refs.rightPage.initChartTimer();
//     this.interval = setInterval(async () => {
//
//       try{
//         if (lock){
//           return
//         }
//         lock=true;
//         await this.$refs.leftPage.updateLeftData();
//           // await this.$refs.middlePage.initChart();
//           await sleep(3);
//           await this.$refs.rightPage.updateRightData();
//       }finally {
//         lock=false;
//       }
//     }, 5000)
//   },
//   created() {
//
//     let MaintainerToken = global.$utils.data.get("","token");
//
//     if (!MaintainerToken&&window.localStorage.getItem('token')=='{"data":""}' ){
//       return
//     }else {
//     this.getCustomerInfo()
//     }
//     let router_path = this.$route.path
//     if (router_path == '/largeScreen') {
//       this.isFullScreen = false
//     }
//   },
//   beforeDestroy() {
//     clearInterval(this.interval)
//   },
//   methods: {
//     async getCustomerInfo() {
//       // 加载详情数据
//       let res = await $utils.api.load(
//           `/admin/system/customer/getCustomerInfo`,
//           {},
//           "GET"
//       );
//       if (res && res.data) {
//         this.titles = res.data.customerName+"数字运维服务平台";
//       }
//     },
//     autodivheight() {
//       this.sonRefresh = false
//       this.$nextTick(() => {
//         this.sonRefresh = true
//       })
//     },
//     showIsFull() {
//       if (!screenfull.isEnabled) {
//         alert('您的浏览器不支持全屏,请切换其他浏览器重新尝试')
//         return false
//       }
//       this.isShow = !this.isShow
//       screenfull.toggle()
//       this.sonRefresh = false
//       this.$nextTick(() => {
//         this.sonRefresh = true
//       })
//     },
//     cancelLoading() {
//       setTimeout(() => {
//         this.loading = false
//       }, 500)
//     },
//     initChart() {
//       // let q = {}
//       // $utils.api
//       //   .load('authCheck', q, 'post')
//       //   .then((res) => {
//       //     // if (res.code != 200) {
//       //     //   // 登录
//       //     //   $utils.url.push({ name: 'login' })
//       //     //   return false
//       //     // }
//       //   })
//       //   .catch((e) => {
//       //     console.log(e)
//       //     // $utils.toast.error('数据异常' + e.message)
//       //   })
//     },
//   },
// }
import urlAppend from "append-query";

export default {
  name: "home",
  components: {
    Iframe,
  },
  data() {
    return {
      url: null,
      Authorization: null,
      customerId: null,
      customerName: "",
      width: null,
      height: null,
      menu_name: "",
      menus: [
        {
          label: "大屏1",
          name: "largeScreen",
          auth: "/admin/dashboard/main",
        },
        {
          label: "大屏2",
          name: "largeScreen_view",
          auth: "/admin/dashboard/main",
        },
      ],
    };
  },
  computed: {},
  created() {
    let route = this.$route;
    if (route) {
      this.menu_name = route.name;
    }
  },
  mounted() {
    const me = this;

    me.Authorization = global.$utils.data.get("", "token");
    me.customerId = window.localStorage.getItem("customerId");
    me.customerName =
      window.localStorage.getItem("customerName") + "数字运维服务平台";

    me.url =
      "https://dpksh.hi-eweibao.com/#/?" +
      // "http://localhost:8080/#/?" +
      "customerId=" +
      me.customerId +
      "&customerName=" +
      me.customerName;
    // let uuid = this.buildShortUUID();
    // // me.url = 'https://dev.gemcoder.com:7779/front/development/view/95caf460e82f453e873ad63744838d68$$0$$c234faa72515478aaaa209382af25b53?token='+me.Authorization+"&customerId="+me.customerId+"&customerName="+me.customerName+"&uniqueId="+uuid;
    // me.url =
    //   "https://uihkmed.hi-eweibao.com/front/development/view/95caf460e82f453e873ad63744838d68$$0$$c234faa72515478aaaa209382af25b53?token=" +
    //   me.Authorization +
    //   "&customerId=" +
    //   me.customerId +
    //   "&customerName=" +
    //   me.customerName +
    //   "&uniqueId=" +
    //   uuid;

    // // me.url = 'https://uihkmed.hi-eweibao.com'

    this.viewport = new Viewport(this);
  },
  methods: {
    selectMenu(name) {
      if (this.menu_name !== name) {
        setTimeout(() => {
          this.$destroy();
        }, 100);
        $utils.url.push({ name: name, params: { refresh: true } });
      }
    },
    buildShortUUID() {
      let unique = 0;
      const time = Date.now();
      const random = Math.floor(Math.random() * 1000000000);
      // eslint-disable-next-line no-undef
      unique++;
      return random + unique + String(time);
    },
    onC() {
      if (navigator.clipboard && window.isSecureContext) {
        // 支持 Clipboard API 且是 HTTPS 环境
        navigator.clipboard
          .writeText(this.url)
          .then(() => alert("链接已复制"))
          .catch((err) => console.error(err));
      } else {
        // 降级方案（兼容 HTTP 或旧浏览器）
        this.fallbackCopy(this.url);
      }
      // let case1 = document.getElementById("iframe");
      // if (this.fullscreen) {
      //   if (document.exitFullscreen) {
      //     document.exitFullscreen();
      //   } else if (document.webkitCancelFullScreen) {
      //     document.webkitCancelFullScreen();
      //   } else if (document.mozCancelFullScreen) {
      //     document.mozCancelFullScreen();
      //   } else if (document.msExitFullscreen) {
      //     document.msExitFullscreen();
      //   }
      // } else {
      //   if (case1.requestFullscreen) {
      //     case1.requestFullscreen();
      //   } else if (case1.webkitRequestFullScreen) {
      //     case1.webkitRequestFullScreen();
      //   } else if (case1.mozRequestFullScreen) {
      //     case1.mozRequestFullScreen();
      //   } else if (case1.msRequestFullscreen) {
      //     // IE11
      //     case1.msRequestFullscreen();
      //   }
      // }
    },
    fallbackCopy(text) {
      const textArea = document.createElement("textarea");
      textArea.value = text;
      textArea.style.position = "fixed";
      textArea.style.opacity = "0";
      document.body.appendChild(textArea);
      textArea.select();

      try {
        document.execCommand("copy");
        alert("✅ 已复制当前链接");
      } catch (err) {
        alert("❌ 复制失败，请手动复制：\n" + text);
      }

      document.body.removeChild(textArea);
    },
  },
  destroyed() {
    this.viewport.onDestroyed();
  },
};
</script>

<!--<style lang="less" scoped>-->
<!--@import '../../assets/less/index.less';-->
<!--.header_bg {-->
<!--  background-image: url('../../assets/img/bg_middle.png');-->
<!--  min-height: 100%;-->
<!--  width: 100%;-->
<!--  background-size: 100% 100%;-->
<!--}-->
<!--.bg {-->
<!--  height: 100%;-->
<!--}-->
<!--.link_btns {-->
<!--  cursor: pointer;-->
<!--  float: right;-->
<!--  padding-right: 20px;-->
<!--  padding-top: 20px;-->
<!--  box-sizing: border-box;-->
<!--}-->
<!--.link_btn {-->
<!--  color: #fff;-->
<!--  float: right;-->
<!--  font-size: 18px;-->
<!--  margin-right: 20px;-->
<!--  margin-top: 15px;-->
<!--  cursor: pointer;-->
<!--}-->
<!--::v-deep .host-body {-->
<!--  // height: 13% !important;-->
<!--  // background: #f5f7fa;-->
<!--}-->
<!--// ::v-deep .single-page .ivu-card {-->
<!--//   height: 99% !important;-->
<!--//   background: #f5f7fa;-->
<!--// }-->
<!--// ::v-deep .ivu-card-body {-->
<!--//   background: #f5f7fa;-->
<!--//   height: 99% !important;-->
<!--// }-->
<!--.title{-->
<!--  position: relative;-->
<!--}-->
<!--.title-text{-->
<!--  position: absolute;-->
<!--  top: -20px;-->
<!--}-->
<!--</style>-->
